// extracted by mini-css-extract-plugin
var _1 = "nVnAStTE";
var _2 = "wBbRVxuG";
var _3 = "BeqShwke";
var _4 = "e1TDmGFi";
var _5 = "BeqShwke";
var _6 = "e1TDmGFi";
var _7 = "uhxTXon1";
var _8 = "uhxTXon1";
export { _1 as "amount", _2 as "price", _3 as "price-and-buy", _4 as "price-and-volume", _5 as "priceAndBuy", _6 as "priceAndVolume", _7 as "volume-and-cost_per_unit", _8 as "volumeAndCostPerUnit" }
